// extracted by mini-css-extract-plugin
export default {"container":"PageNotFound_container__MESXA","message-box":"PageNotFound_message-box__UJhri","message":"PageNotFound_message__88j3j","code":"PageNotFound_code__cQUeA"};